import React from "react";
import AdminFeatureTour, {
  markTourSeen,
  shouldAutoStartTour,
} from "../../components/AdminFeatureTour";

export const THEMEUPDATE_TOUR_STORAGE_KEY = "sl_admin_themeupdate_tour_seen_v1";

export const THEMEUPDATE_TOUR_STEPS = [
  {
    id: "welcome",
    target: "tour-gc-header",
    tab: "avatars",
    title: "Game Content",
    body: "This page is where you add avatars, board size and colours, and quiz questions for the theme.",
  },
  {
    id: "tabs",
    target: "tour-gc-tabs",
    tab: "avatars",
    title: "Content tabs",
    body: "Use these tabs for avatars, board size and colours, then questions.",
  },
  {
    id: "avatars",
    target: "tour-gc-avatars",
    tab: "avatars",
    title: "Add Avatar Image",
    body: "Upload Female and Male PNG avatars at 250×250. You can reset a custom avatar back to the default.",
  },
  {
    id: "board-color",
    target: "tour-gc-board-color",
    tab: "board_color",
    title: "Board Size & Colour",
    body: "Choose columns and rows (up to 7×7), pick the three board colours, and preview the layout before saving.",
  },
  {
    id: "questions",
    target: "tour-gc-quiz",
    tab: "questions",
    title: "Add Questions",
    body: "Add, edit, delete, or CSV-import questions. Set Snake/Ladder category and language. Questions are saved on the theme (quiz), not in a questions table.",
  },
];

export default function ThemeUpdateFeatureTour({ open, onClose, onStepChange }) {
  return (
    <AdminFeatureTour
      open={open}
      onClose={onClose}
      steps={THEMEUPDATE_TOUR_STEPS}
      onStepChange={onStepChange}
    />
  );
}

export function markThemeUpdateTourSeen() {
  markTourSeen(THEMEUPDATE_TOUR_STORAGE_KEY);
}

export function shouldAutoStartThemeUpdateTour() {
  return shouldAutoStartTour(THEMEUPDATE_TOUR_STORAGE_KEY);
}
